/**
 * @generated SignedSource<<4108862624a770bfdfaa65a8ed4adcee>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type WorkspaceTodoStoresGalleryItem_todo$data = {
  readonly id: string;
  readonly resolvedAtDate: {
    readonly " $fragmentSpreads": FragmentRefs<"FormattedDate">;
  } | null;
  readonly response: {
    readonly images?: ReadonlyArray<{
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"Image_image">;
    }>;
  } | null;
  readonly status: TodoStatus;
  readonly store: {
    readonly id: string;
    readonly name: string;
    readonly timezone: string;
  } | null;
  readonly subTodos: ReadonlyArray<{
    readonly status: TodoStatus;
  }> | null;
  readonly " $fragmentType": "WorkspaceTodoStoresGalleryItem_todo";
};
export type WorkspaceTodoStoresGalleryItem_todo$key = {
  readonly " $data"?: WorkspaceTodoStoresGalleryItem_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"WorkspaceTodoStoresGalleryItem_todo">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WorkspaceTodoStoresGalleryItem_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Store",
      "kind": "LinkedField",
      "name": "store",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timezone",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    (v1/*: any*/),
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "Todo",
      "kind": "LinkedField",
      "name": "subTodos",
      "plural": true,
      "selections": [
        (v1/*: any*/)
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Image",
              "kind": "LinkedField",
              "name": "images",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "Image_image"
                }
              ],
              "storageKey": null
            }
          ],
          "type": "TodoResponseImage",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StoreZonedDate",
      "kind": "LinkedField",
      "name": "resolvedAtDate",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "FormattedDate"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Todo",
  "abstractKey": null
};
})();

(node as any).hash = "64eab4b34d2562f4c16ba110c7e49614";

export default node;
